export { default, getStaticProps } from 'components/pages/TrucksMapPage'
